import React from "react";
import useCardDetails from "./useCardDetails";
import { Table } from "@wac-ui-dashboard/wac_component_library";
import Style from "../SubCards/subCards.module.scss";
import StatusCard from "../../../Global/StatusCard";

const CardDetails = () => {
  const { empDetails, getRow } = useCardDetails();
  return (
    <div className="pro-p-5">
      <div className="pro-d-flex pro-gap-3  pro-d-flex-wrap">
        <StatusCard
          title="Rejected"
          count={empDetails?.rejected ?? "NaN"}
        />
        <StatusCard
          title="Cancelled"
          count={empDetails?.canceled ?? "NaN"}
        />
        <StatusCard
          title="Returned"
          count={empDetails?.returned ?? "NaN"}
        />
      </div>
      <Table
        multiSelect={false}
        data={empDetails?.data || []}
        uniqueID={"_id"}
        fields={empDetails?.fields}
        getRow={getRow}
        assignable={false}
        deletable={false}
        showCheckBox={false}
      />
      
      <div className={Style.sub_parent}>

      
      {empDetails?.remark && (
          <div className={`pro-d-flex ${Style.wrapper}`}>
            <div className={`${Style.wrapper_child}`}>
              <p className=" pro-mb-0">Remark</p>
            </div>
            <span className="pro-d-iniline-block pro-px-2 pro-pe-5 pro-lh-1">
              {" "}
              :{" "}
            </span>
            <div className={`${Style.wrapper_child}`}>
              <p className="pro-ttl pro-mb-0">{empDetails?.remark}</p>
            </div>
          </div>
      )}
      {empDetails?.delivery_time && (
          <div className={`pro-d-flex ${Style.wrapper}`}>
            <div className={`${Style.wrapper_child}`}>
              <p className=" pro-mb-0">Delivery Time</p>
            </div>
            <span className="pro-d-iniline-block pro-px-2 pro-pe-5 pro-lh-1">
              {" "}
              :{" "}
            </span>
            <div className={`${Style.wrapper_child}`}>
              <p className="pro-ttl pro-mb-0">{empDetails?.delivery_time}</p>
            </div>
          </div>
      )}
      {empDetails?.estimate_remarks?.length > 0 && (
          <div className={`pro-d-flex ${Style.wrapper}`}>
            <div className={`${Style.wrapper_child}`}>
              <p className=" pro-mb-0">Remark</p>
            </div>
            <span className="pro-d-iniline-block pro-px-2 pro-pe-5 pro-lh-1">
              {" "}
              :{" "}
            </span>
            <div className={`${Style.wrapper_child}`}>
              <ul className="pro-mb-0 pro-ps-4">
                {empDetails?.estimate_remarks?.map((remark, index) => (
                  <li key={index} className="pro-ttl">{remark}</li>
                ))}
              </ul>
            </div>
          </div>
      )}
      </div>
    </div>
  );
};

export default CardDetails;
